import React, {Component} from "react";
import AddBilateralBidAdmin from "./AddBilateralBidAdminView";
import {BILATERAL_BID_ADMIN_ROUTE} from "../../../../utils/constants/RoutesConstants";
import {Growl} from "primereact/growl";
import {calculateAmount} from "../../../../utils/calculate/Amount";
import {BilateralBidService} from "../../../../service/bilateral/bid/BilateralBidService";
import dateFormat from "dateformat";
import PropTypes from "prop-types";
import {withoutComma} from "../../../../utils/calculate/Amount";
import {LENDER, BORROWER} from "../../../../utils/constants/Constants";
import {isEmptyObject} from "../../../../utils/validator/Objects";

export default class AddBilateralBidAdminContainer extends Component {
    constructor(props) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        super(props);
        this.bilateralBidService = new BilateralBidService();

        this.loading = this.loading.bind(this);
        this.addBilateralOrderAdmin = this.addBilateralOrderAdmin.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.returnBilateralBidPage = this.returnBilateralBidPage.bind(this);
        this.getLenderCounterparts = this.getLenderCounterparts.bind(this);
        this.getBorrowerCounterparts = this.getBorrowerCounterparts.bind(this);
        this.saveDataBidAdmin = this.saveDataBidAdmin.bind(this);
        this.saveBidAdmin = this.saveBidAdmin.bind(this);
        this.saveBidAdminLender = this.saveBidAdminLender.bind(this);
        this.saveBidAdminBorrower = this.saveBidAdminBorrower.bind(this);
        this.getCatalogs = this.getCatalogs.bind(this);

        this.state = {
            isLoading: true,
            catBilateralLender: [],
            catBilateralBorrower: [],
            catInstrument: [],
            bidAdmin: {
                bilateralLenderObj: {},
                bilateralBorrowerObj: {},
                instrumentObj: {},
                account: '',
                rate: '',
                fecValor: dateFormat(today.toString(), "dd/mm/yyyy"),
                validDate: true,
            },
        };

    }

    componentDidMount() {
        let message = this.props.location.message ? this.props.location.message : null;
        if (message !== null && message.severity) {
            this.growl.show({
                severity: message.severity ? message.severity : '',
                summary: message.summary ? message.summary : '',
                detail: message.detail ? message.detail : '', message
            });
        }
        this.getCatalogs();
    }

    getCatalogs(){
        this.loading(true);
        this.bilateralBidService.getCatalogInstrument(true).then(
            res => {
                this.setState({
                    catInstrument: res.data,
                });
                this.bilateralBidService.getCatalogInstitutions(LENDER).then(
                    res => {
                        this.setState({
                            catBilateralLender: res.data,
                        });
                        this.bilateralBidService.getCatalogInstitutions(BORROWER).then(
                            res => {
                                this.setState({
                                    catBilateralBorrower: res.data,
                                });

                            }
                        );
                    }
                );
                this.loading(false);
            }
        );
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleCancel() {
        this.props.history.push({
            pathname: BILATERAL_BID_ADMIN_ROUTE,
        });
    }

    returnBilateralBidPage(message) {
        this.loading(false);
        this.props.history.push({
            pathname: BILATERAL_BID_ADMIN_ROUTE,
            message: message,
        });
    }

    validResponse (res){
        if (res.status!== 200){
            this.growl.show({sticky: true, severity: 'error', summary: 'Error.',
                detail: res.message + ' ' + res.debugMessage});
            this.loading(false);
        } else {
            let message = {
                severity: 'success',
                summary: 'Éxito',
                detail: res.data,
            };
            this.returnBilateralBidPage(message);
        }
    }

    getLenderCounterparts(lenderId) {
        this.loading(true);
        this.bilateralBidService.getLenderCounterparts(lenderId).then(
            res => {
                this.setState({
                    catBilateralBorrower: res.data,
                });
                this.loading(false);
            }
        );
    }

    getBorrowerCounterparts(borrowerId) {
        this.loading(true);
        this.bilateralBidService.getBorrowerCounterparts(borrowerId).then(
            res => {
                this.setState({
                    catBilateralLender: res.data,
                });
                this.loading(false);
            }
        );
    }

    saveDataBidAdmin(event) {
        const {name, value} = event.target;
        this.setState((prevState) => {
            const bidAdminAux = { ...prevState.bidAdmin };
            bidAdminAux[name] = value;
            if (name === 'instrumentObj') {
                bidAdminAux['price24Hours'] = value.price24Hours;
                bidAdminAux['amount'] = this.getAmount(bidAdminAux['price24Hours'], bidAdminAux['titles'])
            } else if (name === 'titles') {
                bidAdminAux['amount'] = this.getAmount(bidAdminAux['price24Hours'], bidAdminAux['titles'])
            } else if (name === 'bilateralLenderObj') {
                this.getLenderCounterparts(value['id']);
            } else if (name === 'bilateralBorrowerObj') {
                this.getBorrowerCounterparts(value['id']);
            }
            return {
                bidAdmin: bidAdminAux,
            };
        });
    }

    getAmount(price, titles) {
        let amount = '';
        if (price !== undefined && titles !== undefined) {
            amount = calculateAmount(price, titles)
        }
        return amount
    }

    validateGeneralFields() {
        let fields = [];

        if (this.state.bidAdmin.instrumentObj.id === undefined) {
            fields.push("Emisora");
        }
        if (this.state.bidAdmin.titles === undefined || this.state.bidAdmin.titles === "" || this.state.bidAdmin.titles === "0") {
            fields.push("Títulos");
        }
        if (this.state.bidAdmin.rate === undefined || this.state.bidAdmin.rate === "" || this.state.bidAdmin.rate === "0") {
            fields.push("Tasa");
        }
        return fields;
    }

    validateLenderFields() {
        let fieldsLender = [];
        if (this.state.bidAdmin.account === "" || this.state.bidAdmin.account === undefined) {
            fieldsLender.push("Cuenta");
        }
        return fieldsLender;
    }

    addBilateralOrderAdmin() {
        let lender = this.state.bidAdmin.bilateralLenderObj;
        let borrower = this.state.bidAdmin.bilateralBorrowerObj;
        let fields = this.validateGeneralFields();

        if (fields.length === 0){
            if (this.isOrderAdmin(lender, borrower)){
                this.saveBidAdmin();
            } else if (this.isOrderAdminLender(lender, borrower)) {
                this.saveBidAdminLender();
            } else if (this.isOrderAdminBorrower(lender, borrower)) {
                this.saveBidAdminBorrower();
            } else {
                this.growl.show({severity: 'error', summary: 'Error.',
                    detail: 'Definir prestamista o prestatario'});
            }
        } else {
            this.showMessage(fields);
        }
    }
    isOrderAdmin(lender, borrower){
        return (!isEmptyObject(lender) && !isEmptyObject(borrower))
    }
    isOrderAdminLender(lender, borrower){
        return (!isEmptyObject(lender) && isEmptyObject(borrower))
    }
    isOrderAdminBorrower(lender, borrower){
        return (isEmptyObject(lender) && !isEmptyObject(borrower))
    }

    getBidRequestBody(institutionObj, bidData){
        return {
            institutionId: institutionObj.id,
            createBidRequest:
                {
                    account: bidData.account,
                    instrumentId: bidData.instrumentObj.id,
                    title: Number(withoutComma(bidData.titles)),
                    rate: bidData.rate
                }
        }
    }

    saveBidAdmin(){
        let fieldsLender = this.validateLenderFields();
        if (fieldsLender.length === 0) {
            alert("Funcionalidad en proceso.")
        } else {
            this.showMessage(fieldsLender);
        }
    }

    saveBidAdminLender(){
        let fieldsLender = this.validateLenderFields();
        if (fieldsLender.length === 0) {
            this.loading(true);
            this.bilateralBidService.addLenderOrderAdmin(
                this.getBidRequestBody(
                    this.state.bidAdmin.bilateralLenderObj,
                    this.state.bidAdmin)
            ).then(
                res => {
                    this.validResponse(res);
                }
            );
        } else {
            this.showMessage(fieldsLender);
        }
    }

    saveBidAdminBorrower() {
        this.loading(true);
        this.bilateralBidService.addBorrowerOrderAdmin(
            this.getBidRequestBody(
                this.state.bidAdmin.bilateralBorrowerObj,
                this.state.bidAdmin)
        ).then(
            res => {
                this.validResponse(res);
            }
        );
    }

    showMessage(fields) {
        let message = "Favor de revisar los siguientes campos: ";

        fields.map(field => {
            message = message + field + ', ';
            return '';
        });
        let lastTwoChar = message.slice(-2);
        if (lastTwoChar === ', ') {
            message = message.slice(0, -2);
        }
        this.growl.show({severity: 'error', summary: 'Error.', detail: message});
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <AddBilateralBidAdmin
            messagesGrowl={messagesGrowl}
            isLoading = {this.state.isLoading}
            catBilateralLender = {this.state.catBilateralLender}
            catBilateralBorrower = {this.state.catBilateralBorrower}
            catInstrument = {this.state.catInstrument}
            today={this.state.today}
            bidAdmin={this.state.bidAdmin}

            loading={this.loading}
            saveDataBidAdmin={this.saveDataBidAdmin}
            addBilateralOrderAdmin={this.addBilateralOrderAdmin}
            handleCancel={this.handleCancel}
        />
    }
};

AddBilateralBidAdminContainer.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
};